import gridView from 'components/gridView';
import 'shared/global';
import 'components/subnav';

try {
    gridView({
        useTemplate: 'castTpl',
        parentContainer: $('#cast-grid'),
        options: {
            endPoint:
                '/shows/{slug}/xhr/cast/page/{page}/size/{size}/xs/{excludeShow}/season/{season}/',
            noDataMessage: 'Cast list is not available.',
            noResizeListener: true
        },
        onFilterSelected: function (value) {
            var pathName = window.location.pathname;
            if (pathName.includes('/season/')) {
                const [pathNameRoot, seasonPart] = pathName.split('season/');
                pathName = pathNameRoot;
            }
            var pageUrl = pathName + 'season/' + value + '/';
            window.history.pushState('', '', pageUrl);
        }
    });
} catch (e) {
    console.error('Cast grid failed to load');
}
